import Cookies from 'universal-cookie';
import { conf, IS_LOCAL_DEV } from 'config/env';

export const getClientToken = () => {
  const cookies = new Cookies();
  let cookieToken = cookies.get(conf.cookieToken);

  // Fallback for local development
  if (!cookieToken && (conf.overrideEnv || IS_LOCAL_DEV)) {
    cookieToken = process.env.REACT_APP_COOKIE_TOKEN;
  }

  return cookieToken;
};
